import { toastr } from "react-redux-toastr"
// api nao deu certo por causa do tratamento de erro

// seguinte o axios eu consigo tratar o erro
// mas, nao consigo passar o token ou refazer

// o api nao consigo tratar erro especifico

//import api from "./../services/api"
import axios from "axios"
import Baseurlaxios from "./../services/baseurlaxios"
// console.log("error: " + error)
// alert("error: " + error)

export function ValidaAcesso(values) {
    return (dispatch) => {
        //      api.post(`/Usuario/auth`, {        
         axios.post(`${Baseurlaxios}/Usuario/auth`, {
            "USULOGIN": values.login,
            "USUSENHA": values.senha,
        }
        )
            .then((response) => {
                if (response.data) {
                    dispatch({
                        type: "USER_LOGIN",
                        payload: response.data
                    })

                    dispatch([
                        CarregaAcessoUsuarios(values.login)
                    ])
                    dispatch([
                        getAcessosEmail()
                    ])
                    dispatch([
                        getAcsUsuCmps()
                    ])
                }
            })
            .catch((error) => {
                
                if (error.response.status === 401) {
                    toastr.warning("Usuário ou senha inválidos");
                }
                else {
                    toastr.error("Erro:authActions ValidaAcesso:  " + error);
                }
            })
    }
}

export function VersaoBackEndyy() {
    return (dispatch) => {
        axios.post(`${Baseurlaxios}/Usuario/Versao`)
            .then((response) => {
                if (response.data) {
                    dispatch({
                        type: "VersaoBackEndxx",
                        payload: response.data
                    })
                }
            })
            .catch((error) => {
                toastr.warning("Busca Versão do backEnd sem acesso ao BackEnd...: " + error)
            })
    }
}

export function AActEnviaEmail(value) {

    return (dispatch) => {
        axios.post(`${Baseurlaxios}/Usuario/EnviaEmail`, {
            "USULOGIN": value,
        })
            .then((response) => {
                if (response.data) {
                    dispatch({
                        type: "ENVIA_EMAIL",
                        payload: response.data
                    }
                    );
                    toastr.success("E-mail enviado com Sucesso ")

                }
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    toastr.warning("E-mail não cadastrado");
                }
                else {
                    toastr.error("Erro: authActions AActEnviaEmail..:  " + error)
                }

            })
    }
}

export function CarregaAcessoUsuarios(loginUsu) {
    return (dispatch) => {
        axios.get(`${Baseurlaxios}/MenuUsuario/permissoes/${loginUsu}`)
            .then((response) => {
                if (response.data) {
                    dispatch({
                        type: "AUTOPMSACS",
                        payload: response.data
                    })
                }
            })
            .catch((error) => {
                toastr.error("Erro:authActions CarregaAcessoUsuarios: " + loginUsu + " - " + error)
            })
    }
}

export function getAcessosEmail() {
    return (dispatch) => {
        axios.get(`${Baseurlaxios}/MenuUsuario/BuscaAcessosEmail`)
            .then((response) => {
                if (response.data) {
                    dispatch({
                        type: "GET_DATA_ACESSOS_DOEMAIL",
                        payload: response.data
                    })
                }
            })
            .catch(error => {
                toastr.error("Erro authActions getAcessosEmail: " + error)
            })
    }
}

export function getAcsUsuCmps() {
    return (dispatch) => {
        axios.get(`${Baseurlaxios}/Tb_Mnu/TodosAcessos`
        )
            .then(response => {
                dispatch({
                    type: "GET_CAMPOS_ACSUSU",
                    payload: response
                })
            })
            .catch(error => {
                toastr.error("Erro authActions getAcsUsuCmps: " + error)
            })
    }
}

export function ShowUsuario(strUsuarioLogin) {
    return {
        type: "SHOW_USU",
        payload: strUsuarioLogin
    }
}

export function logout() {
    return {
        type: "USER_LOGOUT",
        payload: null
    }
}
